import React, {useEffect, useState} from 'react'
import {Grid, Message} from "semantic-ui-react";
import Translate from "../Translate";
import _ from "lodash";
import TranslationFlashCard from "./TranslationFlashCard";
import firebase from "firebase";
import axios from "axios";
import ScrollMenu from "react-horizontal-scrolling-menu";
import {UserVisitedPage} from "../../helpers/UserVisitedPage";
import {CreateRecordingAssignmentOptions} from "../../helpers/CreateRecordingAssignmentOptions";

function TranslationFlashCardWrapper(
    {
        classLevel
    }
) {

    //Options for dropdown
    const languageOptions = [
        {key: 1, text: 'samoan', value: true},
        {key: 2, text: 'english', value: false}
    ];


    //Assignment data
    const [assignmentsDB, setAssignmentsDB] = useState([]);
    const [translationAssignment, setTranslationAssignment] = useState(null);
    const [assignmentNum, setAssignmentNum] = useState(null);
    const [assignmentChosen, setAssignmentChosen] = useState(false);
    const [assignmentOptions, setAssignmentOptions] = useState([]);
    const [samoanSounds, setSamoanSounds] = useState([]);
    const [scrollMenu, setScrollMenu] = useState([]);
    const [cardFlipSound, setCardFlipSound] = useState(new Audio());
    const [soundActive, setSoundActive] = useState([]);
    const [retrievedPictureUrls, setRetrievedPictureUrls] = useState([]);
    const [pictureActive, setPictureActive] = useState([]);

    const [samoanDefault, setSamoanDefault] = useState(true);
    const [flashCards, setFlashCards] = useState([]);
    const [open, setOpen] = useState(false);

    //Hooks for quizzing
    const [startQuiz, setStartQuiz] = useState(false);
    const [rand, setRand] = useState(0);
    const [assignmentLength, setAssignmentLength] = useState(0);
    const [intervalID, setIntervalID] = useState(null);
    const [nextCardTimer, setNextCardTimer] = useState(10000);
    const [flipTimer, setFlipTimer] = useState(5000);
    const [timeoutID, setTimeoutID] = useState(null);

    //UI for loading messages
    const [loading, setLoading] = useState(true);
    const [progress, setProgress]= useState(0);
    const [progressText, setProgressText] = useState('');


    useEffect(() => {
        UserVisitedPage();

        //fetching assignments
        async function fetchData() {
            let retrievedFileNames = [];

            //Fetches the number of assignments in translation assignments
            await firebase.storage().ref().child('assignments/Samoan10' + classLevel + '/translationFCAssignments').listAll()
                .then((data) => {
                    data.items.forEach((folderRef) => {
                        retrievedFileNames.push(folderRef.location.path_.split('/')[3])

                    })
                }).catch(e => console.log(e));
            let tmpAssignments = [];

            //Then fetches assignments by name. Assignments are fetched out of order if not done this way
            for (let i = 1; i <= retrievedFileNames.length; i++) {
                const assignments = firebase.storage().ref().child(`assignments/Samoan10` + classLevel + `/translationFCAssignments/assignment${i}.json`);
                await assignments.getDownloadURL()
                    .then((url)=>axios.get(url))
                    .then(res=>{
                        tmpAssignments.push(res.data);
                        setProgress(prevState => prevState + Math.round(100/ retrievedFileNames.length));
                        setProgressText('Loading assignments')
                    });

            }
            CreateRecordingAssignmentOptions(tmpAssignments, classLevel, 'translationFCData')
                .then((res)=>{
                    setAssignmentOptions(res)

                });

            setAssignmentsDB(tmpAssignments);
        }

        fetchData().then(() => setLoading(false)).catch(e => console.log(e))
    }, []);

    //Changes the card for quizzing
    //Selects a random number, then changes the flash cards on that randNum
    //plays the sound on flip and on change
    const nextCardQuiz = () => {
        const min = 0;
        const max = assignmentLength;
        const randNum = (min + Math.random() * (max - min));
        let randomNumber = Math.floor(randNum)
        setFlashCards([]);
        setFlashCards(
            <Message style={{color: 'white', backgroundColor: 'white', WebkitBoxShadow: 'none'}}>
                <Grid.Column key={rand} width={2}>
                    <TranslationFlashCard samoanPhrase={translationAssignment[randomNumber].samoanPhrase}
                                          englishPhrase={translationAssignment[randomNumber].englishPhrase}
                                          samoanDefault={samoanDefault}
                                          assignmentNum={assignmentNum}
                                          flipTimer={flipTimer}
                                          startQuiz={true}
                                          pictureActive={pictureActive[randomNumber]}
                                          retrievedPictureUrls={retrievedPictureUrls[randomNumber]}
                                          translation={true}
                                          soundActive={soundActive[randomNumber]}
                                          file={translationAssignment[randomNumber].samoanAudio}
                                          color="teal"
                                          responseAudio={cardFlipSound}
                    />
                </Grid.Column>

            </Message>
        );

        setTimeoutID(setTimeout(() => {
            cardFlipSound.play()
        }, flipTimer))
        setFlipTimer(nextCardTimer / 2);
        samoanSounds[randomNumber].play()
    };

    const handleStartQuiz = () => {
        setStartQuiz(true);
        setOpen(false);
        nextCardQuiz()
        setIntervalID(setInterval(() => {

            nextCardQuiz()
        }, nextCardTimer));
    };

    const handleAssignmentChange = (event, {value}) => {
        setProgress(0)
        setAssignmentNum(value);
        setAssignmentLength(assignmentsDB[value].length);
        setStartQuiz(false);
        setRand(null);
        clearTimeout(timeoutID);
        clearInterval(intervalID);
        setLoading(true)

        async function fetchData() {
            setRetrievedPictureUrls([])
            setPictureActive([])
            setAssignmentChosen(false);
            let retrievedQuestionSoundURLS = [];
            let tmpRetrievedPictureUrls = [];
            const allSounds = firebase.storage().ref().child('sounds');
            const allPictures = firebase.storage().ref().child('pictures')
            setTranslationAssignment(assignmentsDB[value]);

            //Backup if no sound is found in the assignment
            const retrievedCardFlipSound = allSounds.child('cardflip.mp3');
            let tmpCardFlipSound;
            let tmpSoundActive = [];
            let tmpPictureActive = [];
            await retrievedCardFlipSound.getDownloadURL().then(url => {
                tmpCardFlipSound = new Audio(url)
                setCardFlipSound(new Audio(url))
            });

            //fetching sounds from assignment
            for (let i = 0; i < assignmentsDB[value].length; i++) {
                const retrievedQuestion = allSounds.child(assignmentsDB[value][i].samoanAudio);

                //If no sound is found, use the card flip sound
                if(assignmentsDB[value][i].samoanAudio === "") {
                    await retrievedCardFlipSound.getDownloadURL().then(url => {
                        retrievedQuestionSoundURLS.push(new Audio(url))
                        tmpSoundActive.push(false);
                        setProgress(prevState => prevState + Math.round(50/ assignmentsDB[value].length));
                        setProgressText('Loading pictures & sounds');
                    });

                    //Else, grab the audio and picture file
                }else {
                    await retrievedQuestion.getDownloadURL().then((url) => {
                        retrievedQuestionSoundURLS.push(new Audio(url))
                        tmpSoundActive.push(true);
                        setProgress(prevState => prevState + Math.round(50/ assignmentsDB[value].length));
                        setProgressText('Loading pictures & sounds');
                    })
                }
                const retrievedPicture = allPictures.child(assignmentsDB[value][i].picture);
                if(assignmentsDB[value][i].picture !== ""){
                    await retrievedPicture.getDownloadURL().then((url)=>{
                        tmpRetrievedPictureUrls.push(url);
                        tmpPictureActive.push(true);
                        setProgress(prevState => prevState + Math.round(50/assignmentsDB[value].length));
                        setProgressText('Loading pictures & sounds')
                    })
                } else {
                    tmpPictureActive.push(false);
                    tmpRetrievedPictureUrls.push("")
                    setProgress(prevState => prevState + Math.round(50/assignmentsDB[value].length));
                    setProgressText('Loading pictures & sounds  ')
                }
            }
            let tmpSamoanSounds = [];
            for (let i = 0; i < retrievedQuestionSoundURLS.length; i++) {
                tmpSamoanSounds.push(retrievedQuestionSoundURLS[i])
            }
            setPictureActive(tmpPictureActive);
            setRetrievedPictureUrls(tmpRetrievedPictureUrls);
            setSamoanSounds(tmpSamoanSounds);
            setSoundActive(tmpSoundActive);
            let tmpFlashCards = (_.times(assignmentsDB[value].length, (i) => (
                <Grid.Column key={i} width={2}>
                    <TranslationFlashCard samoanPhrase={assignmentsDB[value][i].samoanPhrase}
                                          englishPhrase={assignmentsDB[value][i].englishPhrase}
                                          samoanDefault={samoanDefault}
                                          assignmentNum={assignmentNum}
                                          pictureActive={tmpPictureActive[i]}
                                          retrievedPictureUrls={tmpRetrievedPictureUrls[i]}
                                          file={tmpSamoanSounds[i]}
                                          translation={true}
                                          soundActive={tmpSoundActive[i]}
                                          color="teal"
                                          responseAudio={tmpCardFlipSound}
                    />
                </Grid.Column>)
            ));
            setFlashCards(tmpFlashCards);

            setScrollMenu(
                <ScrollMenu
                    data={tmpFlashCards}
                    arrowLeft={ArrowLeft}
                    arrowRight={ArrowRight}
                    scrollBy={1}
                />
            );
        }

        fetchData().then(r => {
            setLoading(false);
            setAssignmentChosen(true);
        }).catch(e => console.log(e))

    };

    //Changes to show samoan or english first
    const handleLanguageChange = (event, {value}) => {
        setSamoanDefault(value);
        let tmpFlashCards = (_.times(translationAssignment.length, (i) => (
            <Grid.Column key={i} width={2}>
                <TranslationFlashCard samoanPhrase={translationAssignment[i].samoanPhrase}
                                      englishPhrase={translationAssignment[i].englishPhrase}
                                      samoanDefault={value}
                                      assignmentNum={assignmentNum}
                                      file={samoanSounds[i]}
                                      pictureActive={pictureActive[i]}
                                      retrievedPictureUrls={retrievedPictureUrls[i]}
                                      soundActive={soundActive[i]}
                                      translation={true}
                                      color="teal"
                                      responseAudio={cardFlipSound}
                />
            </Grid.Column>)
        ));
        setFlashCards(tmpFlashCards)
        setScrollMenu(
            <ScrollMenu
                data={tmpFlashCards}
                arrowLeft={ArrowLeft}
                arrowRight={ArrowRight}
                scrollBy={1}
            />
        );
    };

    //Stops the quiz and resets the flas cards to translation assignment data
    const handleStopQuiz = () => {
        setStartQuiz(false);
        setRand(null);
        clearTimeout(timeoutID);
        clearInterval(intervalID);
        setFlashCards(_.times(translationAssignment.length, (i) => (
            <Grid.Column key={i} width={2}>
                <TranslationFlashCard samoanPhrase={translationAssignment[i].samoanPhrase}
                                      englishPhrase={translationAssignment[i].englishPhrase}
                                      samoanDefault={samoanDefault}
                                      flipTimer={null}
                                      assignmentNum={assignmentNum}
                                      translation={false}
                                      pictureActive={pictureActive[i]}
                                      retrievedPictureUrls={retrievedPictureUrls[i]}
                                      soundActive={soundActive[i]}
                                      file={samoanSounds[i]}
                                      responseAudio={cardFlipSound}
                                      color="teal"/>
            </Grid.Column>)
        ))
    };

    //difficulty change
    const handleSlider = (e) => {
        setNextCardTimer(e.target.value)
        setFlipTimer(nextCardTimer / 2)
    };

    //Used for horizontal scrolling
    const Arrow = ({text, className}) => {
        return (
            <div onClick={handleArrowButton}
                 className={className}
            >{text}</div>
        );

    };
    const handleArrowButton = () => {
        setFlashCards(_.times(translationAssignment.length, (i) => (
            <Grid.Column key={i} width={2}>
                <TranslationFlashCard samoanPhrase={translationAssignment[i].samoanPhrase}
                                      englishPhrase={translationAssignment[i].englishPhrase}
                                      samoanDefault={samoanDefault}
                                      flipTimer={null}
                                      soundActive={soundActive[i]}
                                      translation={true}
                                      pictureActive={pictureActive[i]}
                                      retrievedPictureUrls={retrievedPictureUrls[i]}
                                      assignmentNum={assignmentNum}
                                      file={translationAssignment[i].samoanAudio} color="teal"/>
            </Grid.Column>)
        ));
    };
    const ArrowLeft = Arrow({text: '<', className: 'arrow-prev'});
    const ArrowRight = Arrow({text: '>', className: 'arrow-next'});

    //Updates assignment names with mic emoji
    const updateAssignmentNames = () => {
        CreateRecordingAssignmentOptions(assignmentsDB, classLevel, 'translationFCData')
            .then((res)=>{
                setAssignmentOptions(res)

            });
    };

    return (
        <>
            <Translate
                assignmentOptions={assignmentOptions}
                flashCards={flashCards}
                handleStartQuiz={handleStartQuiz}
                handleSlider={handleSlider}
                handleAssignmentChange={handleAssignmentChange}
                handleLanguageChange={handleLanguageChange}
                assignmentNum={assignmentNum}
                samoanDefault={samoanDefault}
                languageOptions={languageOptions}
                startQuiz={startQuiz}
                handleStopQuiz={handleStopQuiz}
                open={open}
                flipTimer={flipTimer}
                nextCardTimer={nextCardTimer}
                setOpen={setOpen}
                ArrowLeft={ArrowLeft}
                ArrowRight={ArrowRight}
                translationFlashCard={true}
                scrollMenu={scrollMenu}
                loading={loading}
                progress={progress}
                progressText={progressText}
                assignmentChosen={assignmentChosen}
                classLevel={classLevel}
                updateAssignmentNames={updateAssignmentNames}
            />
        </>
    )

}

export default TranslationFlashCardWrapper
